import React, { useState, useEffect } from 'react';
import { errorCallback, makeUrl, succesCallbackEmpty } from '../../const/const';
import { MAKE_CUSTOMER_REQUEST, getFetchRequest, GET_INFO_FTS, MAKE_USER_REQUEST, postFetchRequest } from '../../store/requests';

const validateTin = (value, setError) => {
    let result = false;
    let tin = value;
    setError({ type: '', message: '' });
    if (typeof tin === 'number') {
        tin = tin.toString();
    } else if (typeof tin !== 'string') {
        tin = '';
    }

    if (!tin.length) {
        setError({ type: 'empty', message: 'ИНН пуст' });
    } else if (/[^0-9]/.test(tin)) {
        setError({ type: 'number', message: 'ИНН может состоять только из цифр' });
    } else if ([10, 12].indexOf(tin.length) === -1) {
        setError({ type: 'length', message: 'ИНН может состоять только из 10 или 12 цифр' });
    } else {
        const checkDigit = function (tin, coefficients) {
            var n = 0;
            for (let i in coefficients) {
                n += coefficients[i] * tin[i];
            }
            return parseInt(n % 11 % 10);
        };
        switch (tin.length) {
        case 10:
            var n10 = checkDigit(tin, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
            if (n10 === parseInt(tin[9])) {
                result = true;
            }
            break;
        case 12:
            var n11 = checkDigit(tin, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
            var n12 = checkDigit(tin, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
            if ((n11 === parseInt(tin[10])) && (n12 === parseInt(tin[11]))) {
                result = true;
            }
            break;
        }
        if (!result) {
            setError({ type: 'wrong', message: 'Неправильное ИНН' });
        }
    }
    return result;
};

const checkTinUniqueness = (tin, listOfCustomers, setError) => {
    let result = true;
    listOfCustomers.forEach(it => it.tin===tin?result=false:'');
    if(!result) {
        setError({type:'unique', message:'Пользователь с таким ИНН уже существует'});
    }
    return result;
};

const sortCustomersByDefaultFirst = (list) => {
    if (!Array.isArray(list)) return [];
    return [...list].sort((a, b) => {
        if (a.isDefault === b.isDefault) return 0;
        return a.isDefault ? -1 : 1;
    });
};

const TabCustomer = ({userId, setDefaultCustomer}) => {
    const [addCustomerFormIsOpen, setAddCustomerFormIsOpen] = useState(false);
    const [tin, setTin] = useState('');
    const [kpp, setKpp] = useState('');
    const [organizationName, setOrganizationName] = useState('');
    const [legalAddress, setLegalAddress] = useState('');
    const [postalAddress, setPostalAddress] = useState('');
    const [error, setError] = useState({ type: '', message: '' });
    const [customersList, setCustomersList] = useState([]);
    const [isAutoFilled, setIsAutoFilled] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingCustomerId, setEditingCustomerId] = useState(null);

    const succesCustomerInfoCallback = (response) => {
        if (response.length) {
            setCustomersList(sortCustomersByDefaultFirst(response));
            const defaultCustomer = response.find(it => it.isDefault);
            if (defaultCustomer) {
                setDefaultCustomer(defaultCustomer.name);
            } else {
                setDefaultCustomer('');
            }
        } else {
            setAddCustomerFormIsOpen(true);
            setDefaultCustomer('');
        }
    };

    const succesCustomerByTinCallback = (response) => {
        setKpp(response.kpp);
        setOrganizationName(response.name);
        setLegalAddress(response.legal_address);
        setPostalAddress(response.legal_address);
        setIsAutoFilled(true);
    };

    const saveNewCustomerCallback = (response) => {
        // Обрабатываем неуспех
        if (!response || (typeof response.ok === 'boolean' && !response.ok) || (typeof response.ok !== 'boolean' && !response.id)) {
            setError({ type: 'save', message: 'Не удалось сохранить организацию' });
            return;
        }
        setAddCustomerFormIsOpen(false);
        setIsAutoFilled(false);
        if(customersList.length===0) {  
            setCustomersList(prev=> [...prev, {id:response.id, tin, kpp, legalAddress, postalAddress, name: organizationName, isDefault: true}]);
            setDefaultCustomer(organizationName);
            // Сохраняем на сервере выбор дефолтного, не пересортировывая локально
            postFetchRequest(makeUrl([MAKE_CUSTOMER_REQUEST, response.id, '/default/']), '', succesCallbackEmpty, errorCallback, true);
        } else {
            // Если пришёл объект, добавим его; иначе ничего не делаем
            if (response && response.id) {
                setCustomersList(prev=> [...prev, response]);
            }
        }
    };

    const updateCustomerCallback = (response) => {
        // Если пришёл объект Response, проверим статус
        if (response && typeof response.ok === 'boolean') {
            if (!response.ok) {
                setError({ type: 'save', message: 'Не удалось сохранить организацию' });
                return;
            }
        } else if (!response || (response && !response.id)) {
            setError({ type: 'save', message: 'Не удалось сохранить организацию' });
            return;
        }

        // Успех
        setAddCustomerFormIsOpen(false);
        setIsEditing(false);
        setEditingCustomerId(null);
        setError({ type: '', message: '' });
        setCustomersList(prev => prev.map(it => {
            if (it.id === (response?.id || editingCustomerId)) {
                return {
                    ...it,
                    tin,
                    kpp,
                    legalAddress,
                    postalAddress,
                    name: organizationName,
                };
            }
            return it;
        }));
    };

    const handleSaveNewCustomer = () => {
        if (isEditing) {
            const data = { kpp, legalAddress, postalAddress, name: organizationName };
            postFetchRequest(makeUrl([MAKE_CUSTOMER_REQUEST, editingCustomerId, '/']), data, updateCustomerCallback, errorCallback, true);
        } else {
            if (tin && checkTinUniqueness(tin, customersList, setError)) {
                const data = {tin, kpp, legalAddress, postalAddress, name: organizationName};
                postFetchRequest(makeUrl([MAKE_USER_REQUEST, userId, '/customer/']), data, saveNewCustomerCallback, errorCallback);
            }
        }
    };

    useEffect(() => {
        if (userId) {
            getFetchRequest(makeUrl([MAKE_USER_REQUEST, userId, '/customer/']), succesCustomerInfoCallback, errorCallback);
        }
    }, [userId]);

    const handleFillTin = (e) => {
        setTin(e.target.value);
        setError({type: '', message: ''});
        setIsAutoFilled(false);
        if (validateTin(e.target.value, setError)) {
            const pathTin = e.target.value;
            getFetchRequest(makeUrl([GET_INFO_FTS, pathTin, '/']), succesCustomerByTinCallback, errorCallback);
        }
    };

    const handleSetDefault = (item) => {
        const coppiedArray = customersList.map(it => ({...it, isDefault: it.id === item.id}));
        // Не меняем порядок при переключении, только отмечаем выбранного
        setCustomersList(coppiedArray);
        setDefaultCustomer(item.name);
        postFetchRequest(makeUrl([MAKE_CUSTOMER_REQUEST, item.id, '/default/']), '', succesCallbackEmpty, errorCallback, true);
    };

    const handleOpenNewCustomerForm = () => {
        setTin('');
        setKpp('');
        setLegalAddress('');
        setPostalAddress('');
        setOrganizationName('');
        setError({ type: '', message: '' });
        setIsAutoFilled(false);
        setIsEditing(false);
        setEditingCustomerId(null);
        setAddCustomerFormIsOpen(!addCustomerFormIsOpen);
    };

    const handleOpenEditCustomerForm = (e, item) => {
        e.stopPropagation();
        setIsEditing(true);
        setEditingCustomerId(item.id);
        setTin(item.tin || '');
        setKpp(item.kpp || '');
        setOrganizationName(item.name || '');
        setLegalAddress(item.legalAddress || '');
        setPostalAddress(item.postalAddress || '');
        setError({ type: '', message: '' });
        setIsAutoFilled(true); // В режиме редактирования «Сохранить» должно быть доступно
        setAddCustomerFormIsOpen(true);
    };

    return (
        <>
            <div className="setup-customer__section">
                <h3 className="setup-customer__title">{addCustomerFormIsOpen ? (isEditing ? 'Редактировать организацию' : 'Новая организация') : 'Ваша организация'}</h3>
                {!addCustomerFormIsOpen ? (
                    <>
                        {customersList.length ? (
                            <div className="setup-customer__cards">
                                {customersList.map(it => {
                                    return (
                                        <div key={it.id} className={`setup-customer__card${!it.isDefault ? ' non-active' : ''}`} onClick={() => handleSetDefault(it)}>
                                            <div className="setup-customer__card-details">
                                                <div className="setup-customer__detail-row">
                                                    <span className="setup-customer__detail-label">Название</span>
                                                    <span className="setup-customer__detail-value">{it.name}</span>
                                                </div>
                                                <div className="setup-customer__detail-row">
                                                    <span className="setup-customer__detail-label">ИНН</span>
                                                    <span className="setup-customer__detail-value">{it.tin}</span>
                                                </div>
                                                <div className="setup-customer__detail-row">
                                                    <span className="setup-customer__detail-label">КПП</span>
                                                    <span className="setup-customer__detail-value">{it.kpp}</span>
                                                </div>
                                                <div className="setup-customer__detail-row">
                                                    <span className="setup-customer__detail-label">Юридический адрес</span>
                                                    <span className="setup-customer__detail-value setup-customer__detail-value--multiline double-line">{it.legalAddress}</span>
                                                </div>
                                                <div className="setup-customer__detail-row">
                                                    <span className="setup-customer__detail-label">Адрес грузополучателя</span>
                                                    <span className="setup-customer__detail-value setup-customer__detail-value--multiline double-line">{it.postalAddress && it.postalAddress.trim() ? it.postalAddress : '−'}</span>
                                                </div>
                                            </div>
                                            <div className="setup-customer__card-footer">
                                                <label className="setup-customer__switch" onClick={(e) => e.stopPropagation()}>
                                                    <span className="setup-customer__switch-text">Выбрать</span>
                                                    <input
                                                        type="checkbox"
                                                        checked={it.isDefault}
                                                        onChange={() => handleSetDefault(it)}
                                                        className="setup-customer__switch-input"
                                                    />
                                                    <span className="setup-customer__switch-slider"></span>
                                                    
                                                </label>
                                                <button type="button" className="setup-customer__edit-action-btn" onClick={(e) => handleOpenEditCustomerForm(e, it)}>Редактировать</button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <p className="setup-customer__new">ДЛЯ ОФОРМЛЕНИЯ ПОКУПКИ СОЗДАЙТЕ ПОКУПАТЕЛЯ</p>
                        )}
                        <div className="setup-customer__add-button">
                            <button className="setup-customer__add-btn" onClick={handleOpenNewCustomerForm}>
                                + Добавить организацию
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="setup-customer__form-section">
                        <form className="profile-form setup-customer__form">
                            <label name="organization-name" className="profile-form__item">Название
                                <input className={`profile-form__input ${isEditing ? '' : 'orange-bg'}`} placeholder="−" value={organizationName} onChange={(e) => setOrganizationName(e.target.value)} disabled={isEditing}/>
                            </label>
                            <label name="inn" className="profile-form__item">ИНН {!isEditing && (<span className="profile-form__item-hint">? <span className="profile-form__item-hint-text inn-hint">Введите ИНН для автоматического заполнения профиля.</span></span>)}
                                <input className={`profile-form__input ${isEditing ? '' : 'orange-bg'}`} placeholder="−" value={tin} onChange={(e) => handleFillTin(e)} disabled={isEditing} />
                                {error.type&&error.type!=='unique'? <p className='alert'>{error.message}</p> : ''}
                            </label>
                            <label name="kpp" className="profile-form__item">КПП
                                <input className="profile-form__input orange-bg" placeholder="−" value={kpp} onChange={(e) => setKpp(e.target.value)}/>
                            </label>
                            <label name="legal-address" className="profile-form__item">Юридический адрес
                                <textarea className="profile-form__input double-line orange-bg" placeholder="−" value={legalAddress} onChange={(e) => setLegalAddress(e.target.value)}></textarea>
                            </label>
                            <label name="postal-address" className="profile-form__item">Адрес грузополучателя <span className="profile-form__item-hint">? <span className="profile-form__item-hint-text docs-hint">Указывается в отгрузоочных документах.</span></span>
                                <textarea className="profile-form__input double-line orange-bg" placeholder="−" value={postalAddress} onChange={(e) => setPostalAddress(e.target.value)}></textarea>
                            </label>
                            <div className="profile-form__submit-section setup-org">
                                <button 
                                    className={'close-change-password-btn'} 
                                    type="button" 
                                    onClick={handleOpenNewCustomerForm}
                                >
                                    Отменить
                                </button>
                                <button 
                                    onClick={handleSaveNewCustomer} 
                                    className={`order-detail-btn order-detail-btn-submit setup-customer__button ${(!isEditing && !isAutoFilled) ? 'button_disabled' : ''}`}
                                    type="button" 
                                    disabled={!isEditing && !isAutoFilled}
                                >
                                    Сохранить
                                </button>
                            </div>
                            {error.type&&error.type==='unique'? <p className='alert alert__bottom'>{error.message}</p> : ''}
                            {error.type&&error.type==='save'? <p className='alert alert__bottom'>{error.message}</p> : ''}
                        </form>
                    </div>
                )}
            </div>
        </>
    );
};

export default TabCustomer;